import { render, staticRenderFns } from "./SnapsheetPage.vue?vue&type=template&id=bbee9964&scoped=true&"
import script from "./SnapsheetPage.vue?vue&type=script&lang=js&"
export * from "./SnapsheetPage.vue?vue&type=script&lang=js&"
import style0 from "./SnapsheetPage.vue?vue&type=style&index=0&id=bbee9964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbee9964",
  null
  
)

export default component.exports